import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./App.css";
import "../index.scss";
import "./Sidemenu.scss";
import GroupMenu from './GroupMenu';
import ScanMenu from './ScanMenu';
import { getGroup, getUnit } from "../actions";

const mapStateToProps = null;

const mapDispatchToProps = dispatch => ({
  getGroup: payload => dispatch(getGroup(payload)),  
  getUnit: payload => dispatch(getUnit(payload))  
});


const Sidemenu = ({ getGroup, getUnit }) => {
  const gMenuClear = () => {
    getGroup('');
    getUnit('');
  };
  // getGroup('');
  
  return (
  <div
    className="nav-side-menu"
    style={{ textAlign: "left", marginLeft: "0.2%" }}
  >
    <i
      className="fa fa-bars fa-2x toggle-btn"
      data-toggle="collapse"
      data-target="#menu-content"
    ></i>
    <header className="App-header" style={{ flexDirection: "raw" }}>
      <Link to="/" style={{ marginLeft: "7px", marginTop: '18px' }}>
        <img src="/images/logo.png" alt="citajte o" />
      </Link>
    </header>

    <div className="menu-list">
      <ul id="menu-content" className="menu-content collapse out">
        <div className="menu-sect-one" style={{ fontSize: "1em", textAlign: 'justify' }}>
          <Link to="/" onClick={ gMenuClear }>
            home
          </Link>
          <Link className="a_2" to="/search-terms" onClick={ gMenuClear } style={{ display: 'none' }} >
            pretraga
          </Link>
        </div>

        <ScanMenu></ScanMenu>
        <GroupMenu></GroupMenu>

        <div className="points-p">
          <img src="/images/tackice.jpg" alt="citajte o" />
        </div>
        <Link to="/about" location={{ search: "?id=2" }} className="a-m" onClick={ gMenuClear }>
          o projektu
        </Link>
        <Link to="/copyright" className="a-m" onClick={ gMenuClear }>
          autorska prava
        </Link>
        <div className="points-p">
          <img src="/images/tackice.jpg" alt="citajte o" />
        </div>
        <Link to="/artists" className="a-m" onClick={ gMenuClear }>
          UMETNICI
        </Link>
        {/* <Link to="/artists" className="a-m" onClick={ gMenuClear }>
          UMETNIČKE GRUPE
        </Link> */}
        <Link to="/art-movements-and-phenomena" className="a-m" onClick={ gMenuClear }>
          UMETNIČKI PRAVCI I POJAVE
        </Link>
        {/* <Link to="/art-movements-and-phenomena" className="a-m" onClick={ gMenuClear }>
          {" "}
          STALNE MANIFESTACIJE I IZLOŽBE
        </Link> */}
        <Link to="/g/muzej-savremene-umetnosti" className="a-m" >
          MUZEJ SAVREMENE UMETNOSTI
        </Link>
        <div className="points-p">
          <img src="/images/tackice.jpg" alt="citajte o" />
        </div>
        {/* <Link to="/hemeroteka" className="a-m" onClick={ gMenuClear }>
          HEMEROTEKA
        </Link> */}
        {/* <Link to="/document-view" className="a-m" onClick={ gMenuClear }>
          Test strana pdf{" "}
        </Link> */}
        <a href="http://www.facebook.com/citajteo.msub" target="_blank" title="Facebook Čitajte o" style={{ marginTop: '3em', marginBottom: '3em' }} >
          <img src="/images/facebook_02.png" alt="fb citajte o" />
        </a>
      </ul>
    </div>
  </div>
)
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidemenu);
